import $api from "../http";
import { AxiosResponse } from "axios";
import { INews, INewsRes } from "../models/INews";
import { getNewsUrl } from "../utils";

export default class NewsService {
  static async fetchList(
    status: string[],
    page: number
  ): Promise<AxiosResponse<INewsRes>> {
    const url = getNewsUrl(`/news?page=${page}&`, status) || "/news";
    return await $api.get<INewsRes>(url);
  }

  static async fetchCreateOne(data: INews): Promise<AxiosResponse<boolean>> {
    return await $api.put<boolean>("/news", data);
  }

  static async fetchUpdateOne(data: INews): Promise<AxiosResponse<boolean>> {
    return await $api.post<boolean>("/news", data);
  }

  static async fetchDeleteOne(
    id: string | undefined
  ): Promise<AxiosResponse<boolean>> {
    return await $api.delete<boolean>(`/news/${id}`);
  }
}
